"use client";

import { useCurrentUser } from "@/hooks/use-current-user";
import type { DetailedListing } from "@/lib/types";
import { useEffect } from "react";

export const VIEWED_LISTINGS_KEY = "venturu_viewedListings";

export type ListingLoggedOutSeenTrackerProps = {
  listing: DetailedListing;
};

export function ListingLoggedOutSeenTracker({
  listing,
}: ListingLoggedOutSeenTrackerProps) {
  const { user, loaded } = useCurrentUser();

  useEffect(() => {
    if (!loaded || user) {
      return;
    }

    const current = localStorage.getItem(VIEWED_LISTINGS_KEY);
    let listToSet: number[] = [];

    if (current) {
      try {
        const parsedList = JSON.parse(current);

        if (Array.isArray(parsedList)) {
          if (parsedList.includes(listing.id)) {
            return;
          }

          parsedList.push(listing.id);
          listToSet = parsedList;
        } else {
          listToSet = [listing.id];
        }
      } catch (err) {
        console.error("Error parsing viewed listings from localStorage", err);
        listToSet = [listing.id];
      }
    } else {
      listToSet = [listing.id];
    }

    localStorage.setItem(VIEWED_LISTINGS_KEY, JSON.stringify(listToSet));
  }, [user, loaded]);

  return null;
}
